// src/services/patchUltimaAtualizacaoPga3321.js
import { db } from "../firebase";
import {
  collection,
  getDocs,
  doc,
  getDoc,
  setDoc
} from "firebase/firestore";

/**
 * PATCH CIRÚRGICO:
 * Para cada usuário que tiver idInterno === "3321" na categoria melhorfilme do modo pga-indicados
 * (dentro de snapDropdown2026/dados),
 * recalcula a ultimaAtualizacao do modo pga-indicados como a data MAIS RECENTE entre as categorias
 * (usando dataAtualizacao ISO já existente nas categorias),
 * e grava:
 * - usuarios/{uid}/snapDropdown2026/dados -> pga-indicados.ultimaAtualizacao
 * - ranking/usuarios/{uid}/pontos -> pga-indicados.ultimaAtualizacao
 *
 * NÃO altera pontos, porcentagem, totalPontos, nem dataAtualizacao das categorias.
 */
export async function patchUltimaAtualizacaoPga3321() {
  const modoFinal = "pga-indicados";
  const categoriaAlvo = "melhorfilme";
  const idAlvo = "3321";

  console.log("🩹 PATCH (início)", { modoFinal, categoriaAlvo, idAlvo });

  const usuariosSnap = await getDocs(collection(db, "usuarios"));

  let afetados = 0;
  let ignorados = 0;
  let semDados = 0;

  for (const usuarioDoc of usuariosSnap.docs) {
    const uid = usuarioDoc.id;

    const docDadosRef = doc(db, `usuarios/${uid}/snapDropdown2026/dados`);
    const docDadosSnap = await getDoc(docDadosRef);

    if (!docDadosSnap.exists()) {
      semDados++;
      continue;
    }

    const dadosTudo = docDadosSnap.data() || {};
    const dadosModo = dadosTudo[modoFinal];

    if (!dadosModo || typeof dadosModo !== "object") {
      ignorados++;
      continue;
    }

    const melhorFilme = dadosModo[categoriaAlvo];
    if (!melhorFilme || typeof melhorFilme !== "object") {
      ignorados++;
      continue;
    }

    // 1) Verificar se existe idInterno "3321" em alguma posição da categoria melhorfilme
    let temId = false;
    for (const [pos, dados] of Object.entries(melhorFilme)) {
      if (pos === "dataAtualizacao" || pos === "pontos") continue;
      if (!dados || typeof dados !== "object") continue;

      const id = String(dados.idInterno || "").trim();
      if (id === idAlvo) {
        temId = true;
        break;
      }
    }

    if (!temId) {
      ignorados++;
      continue;
    }

    // 2) Encontrar a data MAIS RECENTE entre as categorias "melhor..."
    // usando somente dataAtualizacao ISO já existente nas categorias
    let isoMaisRecente = null;

    for (const [chaveCat, catObj] of Object.entries(dadosModo)) {
      if (!chaveCat.startsWith("melhor")) continue;
      if (!catObj || typeof catObj !== "object") continue;

      const iso = catObj.dataAtualizacao;
      if (!iso || typeof iso !== "string") continue;

      // comparação segura para ISO: pode comparar como string,
      // mas vamos comparar como Date para evitar qualquer surpresa
      const t = Date.parse(iso);
      if (Number.isNaN(t)) continue;

      if (!isoMaisRecente) {
        isoMaisRecente = iso;
      } else {
        const tAtual = Date.parse(isoMaisRecente);
        if (!Number.isNaN(tAtual) && t > tAtual) {
          isoMaisRecente = iso;
        }
      }
    }

    if (!isoMaisRecente) {
      console.warn(`⚠️ Usuário ${uid} tem ${idAlvo}, mas não achei dataAtualizacao ISO nas categorias do modo.`);
      ignorados++;
      continue;
    }

    // Se já estiver correto, não grava (evita writes desnecessários)
    const isoAtualModo = dadosModo.ultimaAtualizacao;
    if (isoAtualModo === isoMaisRecente) {
      console.log(`⏭️ ${uid} já estava correto:`, isoMaisRecente);
      afetados++; // conta como tratado, mas sem escrita
      continue;
    }

    // 3) Atualizar SOMENTE ultimaAtualizacao no modo (merge cirúrgico)
    await setDoc(
      docDadosRef,
      { [modoFinal]: { ultimaAtualizacao: isoMaisRecente } },
      { merge: true }
    );

    // 4) Atualizar SOMENTE ultimaAtualizacao do modo no ranking (merge cirúrgico)
    const rankingRef = doc(db, `ranking/usuarios/${uid}/pontos`);
    await setDoc(
      rankingRef,
      { [modoFinal]: { ultimaAtualizacao: isoMaisRecente } },
      { merge: true }
    );

    afetados++;
    console.log(`✅ ${uid} atualizado`, { de: isoAtualModo, para: isoMaisRecente });
  }

  console.log("🩹 PATCH (fim)", { afetados, ignorados, semDados });
  return { afetados, ignorados, semDados };
}
